import {Component, Input, OnInit} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html'
})
export class DetailsComponent implements OnInit {

  @Input() type;
  @Input() data;
  @Input() galleryImages = [];
  @Input() facilities = [];


  galleryOptions = [
    {
      width: '800px',
      height: '600px',
      thumbnails: false,
    },
  ];


  constructor(public activeModal: NgbActiveModal) {

  }

  ngOnInit() {
  }

  splitData(html) {
    return html.split(/\n/);
  }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/dialogs/details/details.component.ts